import {createAsyncAction} from 'typesafe-actions';
import {AxiosError} from 'axios';
import {IVodInfoData, IGetVodInfo} from 'lib/api/vodInfo';

export const GET_VOD_INFO = 'vodInfo/GET_VOD_INFO';
export const GET_VOD_INFO_SUCCESS = 'vodInfo/GET_VOD_INFO_SUCCESS';
export const GET_VOD_INFO_ERROR = 'vodInfo/GET_VOD_INFO_ERROR';

export const getVodInfoAsync = createAsyncAction(
  GET_VOD_INFO,
  GET_VOD_INFO_SUCCESS,
  GET_VOD_INFO_ERROR,
)<IGetVodInfo, IVodInfoData, AxiosError>();
